import * as React from 'react';
import moment from 'moment';

interface Props {
    value: string;
}

export class TwelveHourTime extends React.PureComponent<Props> {
    render() {
        const { value } = this.props;
        if (!value) return null;
        return moment(value, 'HH:mm:ss').format('h:mm a');
    }
}

export default TwelveHourTime;
